import { computed } from "vue";
import type { ILimitCalculationSendComponentObject } from "nlb-buy-go-library";
import { useLimitCalculationStore } from "../limit-calculation-store";

export function useLimitCalculationSendDataObject() {
    const limitCalculationStore = useLimitCalculationStore();

    const LimitCalculationSendDataObject = computed<ILimitCalculationSendComponentObject>({
        get: () => ({
            email: limitCalculationStore.SendData.email,
            phoneNumber: limitCalculationStore.SendData.phoneNumber,
            prefix: limitCalculationStore.SendData.prefix,
            msisdn: limitCalculationStore.SendData.msisdn,
        }),

        set: (newValues: ILimitCalculationSendComponentObject) => {
            limitCalculationStore.updateSendData({
                email: newValues.email,
                phoneNumber: newValues.phoneNumber,
                prefix: newValues.prefix,
                msisdn: newValues.msisdn,
            });
        },
    });

    return { LimitCalculationSendDataObject };
}
